<kendo-dialog *ngIf="isShowing()" [width]="'auto'" [height]="'auto'" [maxWidth]="'95%'" [maxHeight]="'95%'" (close)="this.onDone.emit(false)" class="kanaal-dialog">
    <kendo-dialog-titlebar class="dialog-header">
        <div class="kanaal-title">
            <div class="title">{{'Kanalen' | translate: 'Kanalen'}}</div>
            @if (!this.electronApi.isElectron()) {
                <button kendoButton (click)="this.open()">{{'Nieuw Venster' | translate: 'Nieuw Venster'}}</button>
            }
            @if (this.jsBridgeService.isDev()) {
                <translation-editor />
            }
            
        </div>
        
    </kendo-dialog-titlebar>
    <kanaal-overview [assign]="this.assign()" [system]="this.hdwConfigService.system()" 
        [presentation]="this.kanaalService.prefferedPresentation()"
        (presentationChanged)="this.onPresentationChanged($event)" />
    <kendo-dialog-actions>
        <button kendoButton (click)="this.onDone.emit(false)" themeColor="primary">{{'Close' | translate: 'Close'}}</button>
    </kendo-dialog-actions>

</kendo-dialog>